import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Router,  NavigationEnd } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

// Models
import { Site } from 'careerpages-base/models/site';

// Services
import { SiteService } from '../../services';

@Component({
  selector: 'app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  private uuidService = require('uuid/v4');

  // The current site
  public site: Site;
  public siteNotFound: boolean = false;

  constructor(
    private router: Router,
    private siteService: SiteService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    // Load the site and update siteNotFound accordingly
    this.site = this.siteService.getSite();

    if (!this.site) {
      this.siteNotFound = true;
    } else if (isPlatformBrowser(this.platformId)) {

      this.router.events.subscribe((event: NavigationEnd) => {
        if (event instanceof NavigationEnd && !this.router.parseUrl(this.router.url).fragment) {
          window.scroll(0, 0);
        }
      });

    }
  }

}
